var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcabamento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.288,
    height: 46.633,
    viewBox: "0 0 54.288 46.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_981",
    "data-name": "Grupo 981",
    transform: "translate(-733.026 -617.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_980",
    "data-name": "Grupo 980",
    transform: "translate(736.775 617.648)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_979",
    "data-name": "Grupo 979",
    transform: "translate(-343.308 128.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6295",
    "data-name": "Caminho 6295",
    d: "M1108.073,502.024v5.856a5.427,5.427,0,0,1-5.427,5.426",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6296",
    "data-name": "Caminho 6296",
    d: "M1090.115,519.8v-4.588a1.91,1.91,0,0,1,1.91-1.91h11.121",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_706",
    "data-name": "Ret\\xE2ngulo 706",
    width: 5.712,
    height: 10.068,
    transform: "translate(1087.151 519.804)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_314",
    "data-name": "Linha 314",
    y2: 10.641,
    transform: "translate(1079.225 508.854)",
    fill: "#fff",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_315",
    "data-name": "Linha 315",
    y2: 4.429,
    transform: "translate(1083.795 508.854)",
    fill: "#fff",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_707",
    "data-name": "Ret\\xE2ngulo 707",
    width: 26.063,
    height: 11.304,
    rx: 0.872,
    transform: "translate(1077.083 496.788)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcabamento);
export default __webpack_public_path__ + "static/media/acabamento.4cb846c9191895aa47f1a2b562d74011.svg";
export { ForwardRef as ReactComponent };